import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { LayoutContainer, MainContent } from './Layout.styles';

// El pie de marca aparece solo en las páginas públicas (headerType="user" con encabezado).
// `footerAttached`: la página termina en un bloque a sangre completa (p. ej. Home) y el pie va pegado.
const Layout = ({ children, showHeader = true, headerType = 'user', footerAttached = false }) => {
  const showFooter = showHeader && headerType === 'user';
  return (
    <LayoutContainer>
      {showHeader && <Header type={headerType} />}
      <MainContent $noBottomPadding={showFooter}>{children}</MainContent>
      {showFooter && <Footer attached={footerAttached} />}
    </LayoutContainer>
  );
};

export default Layout;
